'use client';
import { useState } from 'react';
import { useT, useSite } from '../../lib/i18n';
import { Icon } from '../Icon';

/**
 * 찜 하트 — 가이드 `course-wish`(리스트에서는 `clist-wish` 를 함께 붙인다).
 *
 * 서버가 목록에 `wished` 를 담아 주므로 첫 렌더부터 채워진 상태로 그린다.
 * 누르면 즉시 뒤집고(낙관적) 실패하면 되돌린다 — 하트가 눌리지 않는 것처럼 보이면
 * 회원이 여러 번 누르게 되고, 그때마다 토글이라 결과가 뒤집힌다.
 *
 * 비로그인은 로그인으로 보낸다(돌아올 자리를 next 로 남긴다).
 */
export function WishButton({ productId, wished, className }: {
  productId: number;
  wished: boolean;
  className?: string;
}) {
  const t = useT();
  const { loggedIn } = useSite();
  const [on, setOn] = useState(wished);
  const [busy, setBusy] = useState(false);

  const toggle = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation(); // 카드 전체가 상세로 가는 링크다 — 하트는 그 클릭을 삼킨다
    if (!loggedIn) {
      window.location.href = `/login?next=${encodeURIComponent(window.location.pathname + window.location.search)}`;
      return;
    }
    if (busy) return;
    setBusy(true);
    const next = !on;
    setOn(next);
    try {
      const res = await fetch('/api/members/me/wishes', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ productId }),
      });
      if (!res.ok) setOn(!next);
    } catch {
      setOn(!next);
    } finally {
      setBusy(false);
    }
  };

  return (
    /* 썸네일 위에 얹히는 버튼이라 **미리보기를 막는다**(2026-08-23 사용자 지시) —
       하트 위에 마우스를 올렸는데 영상이 열려 하트를 가리면 누를 수가 없다 */
    <button type="button" data-no-preview
      className={`course-wish${on ? ' on' : ''}${className ? ` ${className}` : ''}`}
      onClick={(e) => void toggle(e)} aria-pressed={on} aria-label={t('prd.wish')}>
      <Icon name="heart" />
    </button>
  );
}
